import { useEffect, useRef } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { initGoogleAnalytics, trackPageView } from "./shared/lib/analytics.ts";

function AnalyticsTracker() {
  const location = useLocation();
  const previousPathRef = useRef<string>("");

  useEffect(() => {
    initGoogleAnalytics();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (previousPathRef.current === path) return;

    previousPathRef.current = path;
    trackPageView(path);
  }, [location]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
